<template>
  <div>
    <div id="lang">
      <button v-on:click="setLocale('fi')">FIN</button>
      |
      <button v-on:click="setLocale('en')">ENG</button>
    </div>
    <div class="container" v-if="questions.length > 0">
      <div class="topic_index">
        <carousel class="101carousel" :per-page="1" :loop="true" :navigationEnabled="true" :paginationEnabled="false" :navigateTo="selectedQ - 1" :mouse-drag="true" :centerMode="false" :adjustableHeight="false" @pageChange="selectQuestion">
          <template v-for="question in questions">
            <slide v-if="question.question.length > 1" :key="question.index">
              <span v-for="translation in question.question" v-bind:key="translation.language" v-show="locale === translation.language">{{ question.index }}&nbsp;:&nbsp;{{ translation.text }}
              </span>
            </slide>
          </template>
        </carousel>
        <Br />
        <router-link v-for="question in questions" :to="{name: 'Topic', params: {id: question.index }}" v-show="question.index === parseInt(selectedQ)" :key="question.index" class="button topic_button is-link">
          <span v-show="locale == 'fi'">Valitse tämä aihe</span>
          <span v-show="locale == 'en'">Choose topic</span>
        </router-link>
        <!-- <p>{{ questions }} </p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import axios from 'axios'

export default {
  components: {
    Carousel,
    Slide
  },
  props: ['start'],
  data () {
    return {
      locale: null,
      questions: [],
      selectedQ: null
    }
  },
  methods: {
    selectQuestion (currentPage) {
      this.selectedQ = parseInt(currentPage + 1)
    },
    setLocale: function (locale) {
      console.log('switching to ' + locale)
      this.locale = locale
      localStorage.setItem('locale', locale)
    }
  },
  async created () {
    const QUESTIONS_PATH = `${process.env.API_PATH}/`
    const response = await axios.get(QUESTIONS_PATH)
    this.questions = response.data.data
  },
  mounted () {
    if (localStorage.locale) {
      this.locale = localStorage.getItem('locale')
      this.selectedQ = localStorage.getItem('last')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Index.vue